$(document).ready(function () {
  
  window.addEventListener('scroll', function() {
    var header = document.querySelector('sticky-header');
    var scrollPosition = window.scrollY;
  
    var scrollThreshold = 1;
  
    if (scrollPosition > scrollThreshold) {
      header.classList.add('sticky-header-scroll');
    } else {
      header.classList.remove('sticky-header-scroll');
    }
  });

  /*  var timer;

    $("#HeaderMenu-colecoes").on("mouseover", function() {
        clearTimeout(timer);
       $("#Details-HeaderMenu-2").attr("open", true);
        $("#HeaderMenu-MenuList-2").fadeIn();
    });

    $("#HeaderMenu-MenuList-2").on("mouseover", function() {
        clearTimeout(timer);
    });

    $("#HeaderMenu-colecoes, #HeaderMenu-MenuList-2").on("mouseout", function() {
        timer = setTimeout(function() {
            $("#HeaderMenu-MenuList-2").fadeOut();
        }, 200); // Adjust the timeout duration as needed
    });*/


  $(".mega-menu__list svg").click(function(){
    if( $(".mega-menu[open]")){
      console.log($("body"))
      $("body").css("overflow", "auto").css("margin-right", "");
      $(".mega-menu[open]").removeAttr("open");
    }
  });

  $("summary#HeaderMenu-colecoes").click(function(){
      $("body").css("overflow", "hidden");
  });
  
});

 